// Full-document render of the Oscar account order-detail view: PageSkeleton
// wrapping the legacy sealy orders page body.
import React from "react";

import { templates } from "@reactivated";

import { OrderDetailPageBody } from "../components/OrderDetailPageBody";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.OrderDetailDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <OrderDetailPageBody {...props} />
    </PageSkeleton>
);
